import React, {useEffect, useState} from "react";
import {moment} from '../../../../../../vendor';
import t from '../../../../helpers/t';
import DatePicker from "react-datepicker";
import {Biscuit} from "../../../../../utils";
import de from "date-fns/locale/de";
import fr from "date-fns/locale/fr";
import en from "date-fns/locale/en-GB";

const ContingentNumbers = (props) => {
    const { contingent, setContingent, existingDisabled} = props;
    const [newItem,setNewItem] = useState(0);
    const contingentNumber = {
        number: 0,
        valid_from:moment().format('YYYY-MM-DD HH:mm:00')
    };
    const addContingentNumber = () => {
        let val = newItem;
        val++;
        setNewItem(val);
        const newItemObject = contingentNumber;
        if(typeof contingent.id !== 'undefined'){
            newItemObject.contingent_id = contingent.id;
        }
        let clone = {};
        Object.assign(clone,contingent);
        clone.contingent_numbers.push(newItemObject);
        console.log("clone",clone)
        setContingent(clone);
    };

    const onChangeField = (e,name, index) => {
        const clone = {}, clone2 = {};
        Object.assign(clone,contingent.contingent_numbers[index]);
        Object.assign(clone2,contingent);
        let date,time;
        switch (name){
            case "valid_from_date_field":
                date = moment(e).format('YYYY-MM-DD');
                time = moment(clone.valid_from).format('HH:mm:00');
                clone.valid_from = moment(date+' '+time).format('YYYY-MM-DD HH:mm:00');
                break;
            case "valid_from_time_field":
                date = moment(clone.valid_from).format('YYYY-MM-DD');
                time = e.target.value;
                clone.valid_from = moment(date+' '+time).format('YYYY-MM-DD HH:mm:00');
                break;
            case "number_field":
                clone.number = e.target.value;
                break;
        }
        clone2.contingent_numbers[index] = clone;
        setContingent(clone2);
    }
    const remove = (index, event) => {
        const clone = {};
        Object.assign(clone,contingent);
        clone.contingent_numbers.map((item,i) => {
            if(item.id === index){
                clone.contingent_numbers.splice(i,1);
            }
        });
        setContingent(clone);
    }
    return (
        <>
            <div className="contingents-form-numbers__content" style={{marginBottom:"50px"}}>
                <div className="row inb-reservation-contingents-list">
                    <header className="medium-12 column" style={{backgroundColor:"#fff"}}>
                        <p className="float-left">
                            <strong style={{color:"#3b3b3b"}}>
                                {t('resources_amount')}
                            </strong>
                        </p>
                    </header>
                    <ul className="inb-tabs">
                        <li className="tabs-title small-3 column"><a href="#"> {t('valid_from',null,'capital')} </a></li>
                        <li className="tabs-title small-2 small-offset-4 column"><a href="#"> {t('count_units')} </a></li>
                    </ul>
                    <div className="contingents-list">
                        {contingent.contingent_numbers.length > 0 && contingent.contingent_numbers.map((contingentNbr,index) =>
                        {
                           return (
                               <>
                               <div className="inb-reservation-contingent-item contingent-number-item row" key = {typeof contingentNbr.id !== 'undefined'?contingentNbr.id:newItem}>

                                   <aside className="inb-c-item__actions" style={{marginTop:"0"}}>
                                       {(existingDisabled === '' || typeof contingentNbr.id === 'undefined') && <button className={"button round contingent-amount-remove "+(contingent.contingent_numbers.length > 1 ?'':'hide')} type="button" onClick={e => {remove(contingentNbr.id,e)}}
                                               title={t('remove')}>
                                           <i className="fi fi-trash"></i>
                                       </button>}
                                   </aside>
                                   <div className="small-6 column">
                                   <div className="input-group inb-price-input-group">
                                       <div className="float-left">
                                           {(existingDisabled === '' || typeof contingentNbr.id === 'undefined')?<DatePicker
                                           key={"inb-form-item-" + Math.floor(Math.random() * 10000)}
                                           className="input-group-field"
                                           dateFormat='dd. MMMM y'
                                           disabled={(existingDisabled !== '' && typeof contingentNbr.id !== 'undefined')?existingDisabled:''}
                                           selected={new Date(contingentNbr.valid_from)}
                                           onChange={date => onChangeField(date,"valid_from_date_field",index)}
                                           onKeyDown={e => {
                                               if (e.keyCode === 8) e.preventDefault();
                                           }}
                                           placeholderText=""
                                           locale={Biscuit.get('user.lang').indexOf('de') >= 0 ? de : (Biscuit.get('user.lang').indexOf('fr') >= 0 ? fr : en)}
                                       />:<input disabled={existingDisabled} className="input-group-field" name="valid_from_date_field" value={moment(contingentNbr.valid_from).format('dd. MMMM y')}/>}
                                       </div>
                                       <input
                                           className="input-group-field"
                                           type="time"
                                           name="valid_from_time_field"
                                           disabled={(existingDisabled !== '' && typeof contingentNbr.id !== 'undefined')?existingDisabled:''}
                                           value={moment(contingentNbr.valid_from).format('HH:mm') }
                                           style={{maxWidth: "40%"}}
                                           onChange={(e)=>{onChangeField(e,"valid_from_time_field",index)}}
                                       />

                                   </div>
                               </div>

                               <div className="hide small-3 small-offset-1 column">
                                   <input
                                       type="text"
                                       disabled="disabled"
                                       value={contingentNbr.valid_from}
                                   />
                               </div>

                               <div className="medium-2 medium-offset-1 column">
                                   <input
                                       className=""
                                       type="text"
                                       name="number_field"
                                       disabled={(existingDisabled !== '' && typeof contingentNbr.id !== 'undefined')?existingDisabled:''}
                                       value={contingentNbr.number}
                                       onChange={(e)=>{onChangeField(e,"number_field",index)}}
                                   />
                               </div>
                               </div>
                               </>
                           )
                        })}
                        
                </div>
                </div>
                <div className="contingent-number__add row text-center">
                    <p style={{margin:"0 auto"}}>
                        <a href="#" onClick={addContingentNumber}> + {t('add_unit')} </a>
                    </p>
                </div>

            </div>
        </>
    )
}

export default ContingentNumbers;